import React from 'react';
import {colorOf} from './colorMap';

/**
 * Farb-Chip vor dem Artikelnamen (Original `swatch`, Zeile 1536). Der Platz
 * ist fest, damit die Artikelnamen auch ohne erkannte Farbe fluchten.
 */
export default function Swatch({title}) {
    const c = colorOf(title || '');

    return (
        <span className="swguide" aria-hidden="true">
            {c ? <span className="swatch" style={{background: c}}/> : null}
        </span>
    );
}
